/**
 * pocketMaps — authoritative registry of connected pocket maps and their parent places.
 *
 * A pocket map (e.g. drowned_road_hush_nook) is a full authoritative room reachable
 * through concealed or interior passages. On the world map/atlas, it projects to its parent
 * place POI rather than drawing a separate overland node or road.
 */

export const POCKET_PARENTS: Readonly<Record<string, string>> = {
  drowned_road_hush_nook: 'drowned_road',
};

/** Own keys only: `in` would also accept inherited names such as `constructor`. */
export function isPocketMap(mapId: string): boolean {
  return Object.prototype.hasOwnProperty.call(POCKET_PARENTS, mapId);
}

export function getPocketParent(mapId: string): string | undefined {
  return isPocketMap(mapId) ? POCKET_PARENTS[mapId] : undefined;
}
